import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ReportsIcon from "@mui/icons-material/Unarchive";
import Divider from "@mui/material/Divider";
import AssignPrescriptionIcon from "@mui/icons-material/NoteAdd";
import { Link } from "@reach/router";
import USER_ROLES from "../common/userroles";
import { withTranslation } from "react-i18next";
import connectionType from "../common/connection-type";

const styles = (theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  textColor: {
    color: "black",
  },
  listItem: {
    "&.MuiButtonBase-root": {
      display: "flex",
      padding: "8px 24px 8px 24px",
    },
  },
});

class NestedList extends React.Component {
  state = {
    open: false,
    Dashboard: true,
    assignprescription: true,
    reports: true,
    assigneditemsreports: true,
    stockeditemsreports: true,
    cancelledItemsReports: true,
    pickedUpitemsreports: true,
    transactionsreports: true,
    enrolledPatientsreports: true,
    DeliveryTech: false,
    isIpayTransactionAllowed: true,
    isTemperatureMonitoringAllowed: true,
    isReturnToStockAllowed: true,
    isSurveyReportAllowed: true,
    isConsultationReportAllowed: true,
    isScheduleConsultationAllowed: true,
    isOutForDeliveryAllowed: true,
    isDeliveredItemsAllowed: true,
    isLoyaltiMembersAllowed: true,
    isOrderStagingViewAllowed: true,
    isConsoleReportAllowed: true,
    payrollDeductionsreports: true,
    inActiveUsresAllowed: true,
    kioskUtilizationAllowed: true,
    isPhiLogsVisible: false,
    isPurgeTrailVisible: false,
    isCycleReview: false,
    isAuditTrailReportAllowed: false,
    isDeliverPrescriptionVisible: false,
    isHL7OrdersViewVisible: false
  };
  handleClick = () => {
    this.setState((state) => ({ open: !state.open }));
  };
  componentDidMount() {
    let permissions = JSON.parse(sessionStorage.getItem("permissions"));
    let _checkUserRole = JSON.parse(sessionStorage.getItem("superadmin"));
    let _isRetailLocal = localStorage.getItem("isRetail");
    let _isRetail;
    if (![undefined, undefined, null, null, ""].includes(_isRetailLocal)) {
      _isRetail = [true, "true"].includes(_isRetailLocal) ? true : false;
    } else {
      _isRetail = false;
    }
    if (_checkUserRole !== USER_ROLES.SUPERADMIN) {
      if (permissions && permissions.length > 0) {
        let permissionObj = {};
        permissions.map((item) => {
          return item.name.trim() === "Weekly Total"
            ? (permissionObj.weeklyTotal = true)
            : item.name.trim() === "Sales"
            ? (permissionObj.sales = true)
            : item.name.trim() === "Accounts"
            ? (permissionObj.accounts = true)
            : item.name.trim() === "Daily Sales States"
            ? (permissionObj.dailySalesStates = true)
            : item.name.trim() === "Consultations"
            ? (permissionObj.consultations = true)
            : item.name.trim() === "View"
            ? (permissionObj.view = true)
            : item.name.trim() === "Assign"
            ? (permissionObj.assign = true)
            : item.name.trim() === "UnAssign"
            ? (permissionObj.unAssign = true)
            : item.name.trim() === "Delete"
            ? (permissionObj.delete = true)
            : item.name.trim() === "Assigned Items"
            ? (permissionObj.assigned = true)
            : item.name.trim() === "Stocked Items"
            ? (permissionObj.stocked = true)
            : item.name.trim() === "Picked Up Items"
            ? (permissionObj.pickedUpItems = true)
            : item.name.trim() === "Transactions"
            ? (permissionObj.transactions = true)
            : item.name.trim() === "Cancelled Items"
            ? (permissionObj.cancelledItems = true)
            : null;
        });
        if (
          permissionObj.weeklyTotal &&
          permissionObj.sales &&
          permissionObj.accounts &&
          permissionObj.dailySalesStates &&
          permissionObj.consultations
        ) {
          this.setState({ Dashboard: true });
        } else {
          this.setState({ Dashboard: false });
        }
        if (
          permissionObj.view &&
          permissionObj.assign &&
          permissionObj.unAssign &&
          permissionObj.delete
        ) {
          this.setState({ assignprescription: true });
        } else {
          this.setState({ assignprescription: false });
        }
        let permissionUser = JSON.parse(
          sessionStorage.getItem("permissionUser")
        );
        if (permissionUser === USER_ROLES.DELIVERYTECH) {
          this.setState({ DeliveryTech: true });
        }
      } else {
        this.setState({ Dashboard: false });
        this.setState({ assignprescription: false });
        this.setState({ reports: false });
      }
    }

    /** Report Permission Start Here */
    // 1. Assigned Items
    if (permissions && permissions.length > 0) {
      const assignedItems = permissions.filter((item) => {
        return item.name.trim() === "Assigned Items" && item.is_allowed === 1;
      });
      if (_checkUserRole === USER_ROLES.SUPERADMIN) {
        this.setState({ assigneditemsreports: true });
      } else {
        if (assignedItems.length > 0) {
          this.setState({
            assigneditemsreports:
              assignedItems[0].is_allowed === 1 ? true : false,
          });
        } else {
          this.setState({ assigneditemsreports: false });
        }
      }
    } else {
      this.setState({ assigneditemsreports: false });
    }

    // 2. Stocked Items
    if (permissions && permissions.length > 0) {
      const stockedItems = permissions.filter((item) => {
        return item.name.trim() === "Stocked Items" && item.is_allowed === 1;
      });
      if (_checkUserRole === USER_ROLES.SUPERADMIN) {
        this.setState({ stockeditemsreports: true });
      } else {
        if (stockedItems.length > 0) {
          this.setState({
            stockeditemsreports:
              stockedItems[0].is_allowed === 1 ? true : false,
          });
        } else {
          this.setState({
            stockeditemsreports: false,
          });
        }
      }
    } else {
      this.setState({ stockeditemsreports: false });
    }

    // 3. Picked Up Items
    if (permissions && permissions.length > 0) {
      const pickedupItems = permissions.filter((item) => {
        return item.name.trim() === "Picked Up Items" && item.is_allowed === 1;
      });
      if (_checkUserRole === USER_ROLES.SUPERADMIN) {
        this.setState({ pickedUpitemsreports: true });
      } else {
        if (pickedupItems.length > 0) {
          this.setState({
            pickedUpitemsreports:
              pickedupItems[0].is_allowed === 1 ? true : false,
          });
        } else {
          this.setState({
            pickedUpitemsreports: false,
          });
        }
      }
    } else {
      this.setState({ pickedUpitemsreports: false });
    }

    // 4. Transactions
    if (permissions && permissions.length > 0) {
      const _transaction = permissions.filter((item) => {
        return item.name.trim() === "Transactions" && item.is_allowed === 1;
      });
      if (_checkUserRole === USER_ROLES.SUPERADMIN) {
        this.setState({ transactionsreports: true });
      } else {
        if (_transaction.length > 0) {
          this.setState({
            transactionsreports:
              _transaction[0].is_allowed === 1 ? true : false,
          });
        } else {
          this.setState({
            transactionsreports: false,
          });
        }
      }
    } else {
      this.setState({ transactionsreports: false });
    }

    // 5. iPay Transactions
    if (permissions && permissions.length > 0) {
      const iPayTransaction = permissions.filter((item) => {
        return (
          item.name.trim() === "iPay Transactions" && item.is_allowed === 1
        );
      });
      if (!_isRetail) {
        if (_checkUserRole === USER_ROLES.SUPERADMIN) {
          this.setState({ isIpayTransactionAllowed: true });
        } else {
          if (iPayTransaction.length > 0) {
            this.setState({
              isIpayTransactionAllowed:
                iPayTransaction[0].is_allowed === 1 ? true : false,
            });
          } else {
            this.setState({ isIpayTransactionAllowed: false });
          }
        }
      } else {
        this.setState({ isIpayTransactionAllowed: false });
      }
    } else {
      this.setState({ isIpayTransactionAllowed: false });
    }

    // 6. Temperature Monitoring
    if (permissions && permissions.length > 0) {
      const temperatureMonitoring = permissions.filter((item) => {
        return (
          item.name.trim() === "Temperature Monitoring" && item.is_allowed === 1
        );
      });
      if (!_isRetail) {
        if (_checkUserRole === USER_ROLES.SUPERADMIN) {
          this.setState({
            isTemperatureMonitoringAllowed: true,
          });
        } else {
          if (temperatureMonitoring.length > 0) {
            this.setState({
              isTemperatureMonitoringAllowed:
                temperatureMonitoring[0].is_allowed === 1 ? true : false,
            });
          } else {
            this.setState({
              isTemperatureMonitoringAllowed: false,
            });
          }
        }
      } else {
        this.setState({ isTemperatureMonitoringAllowed: false });
      }
    } else {
      this.setState({ isTemperatureMonitoringAllowed: false });
    }

    // 7. Return to stock
    if (permissions && permissions.length > 0) {
      const returnToStock = permissions.filter((item) => {
        return item.name.trim() === "Return to stock" && item.is_allowed === 1;
      });
      if (_checkUserRole === USER_ROLES.SUPERADMIN) {
        this.setState({ isReturnToStockAllowed: true });
      } else {
        if (returnToStock.length > 0) {
          this.setState({
            isReturnToStockAllowed:
              returnToStock[0].is_allowed === 1 ? true : false,
          });
        } else {
          this.setState({
            isReturnToStockAllowed: false,
          });
        }
      }
    } else {
      this.setState({ isReturnToStockAllowed: false });
    }

    // 8. Survey Report
    if (permissions && permissions.length > 0) {
      const surveyReport = permissions.filter((item) => {
        return item.name.trim() === "Survey Report" && item.is_allowed === 1;
      });
      if (!_isRetail) {
        if (_checkUserRole === USER_ROLES.SUPERADMIN) {
          this.setState({ isSurveyReportAllowed: true });
        } else {
          if (surveyReport.length > 0) {
            this.setState({
              isSurveyReportAllowed:
                surveyReport[0].is_allowed === 1 ? true : false,
            });
          } else {
            this.setState({
              isSurveyReportAllowed: false,
            });
          }
        }
      } else {
        this.setState({
          isSurveyReportAllowed: false,
        });
      }
    } else {
      this.setState({ isSurveyReportAllowed: false });
    }

    // 9. Consultation Report
    if (permissions && permissions.length > 0) {
      const consultationReport = permissions.filter((item) => {
        return (
          item.name.trim() === "Consultation Report" && item.is_allowed === 1
        );
      });
      if (!_isRetail) {
        if (_checkUserRole === USER_ROLES.SUPERADMIN) {
          this.setState({
            isConsultationReportAllowed: true,
          });
        } else {
          if (consultationReport.length > 0) {
            this.setState({
              isConsultationReportAllowed:
                consultationReport[0].is_allowed === 1 ? true : false,
            });
          } else {
            this.setState({
              isConsultationReportAllowed: false,
            });
          }
        }
      } else {
        this.setState({ isConsultationReportAllowed: false });
      }
    } else {
      this.setState({ isConsultationReportAllowed: false });
    }

    // 10. Schedule Consultation
    if (permissions && permissions.length > 0) {
      const scheduleConsultation = permissions.filter((item) => {
        return (
          item.name.trim() === "Schedule Consultation" && item.is_allowed === 1
        );
      });
      if (!_isRetail) {
        if (_checkUserRole === USER_ROLES.SUPERADMIN) {
          this.setState({
            isScheduleConsultationAllowed: true,
          });
        } else {
          if (scheduleConsultation.length > 0) {
            this.setState({
              isScheduleConsultationAllowed:
                scheduleConsultation[0].is_allowed === 1 ? true : false,
            });
          } else {
            this.setState({
              isScheduleConsultationAllowed: false,
            });
          }
        }
      } else {
        this.setState({
          isScheduleConsultationAllowed: false,
        });
      }
    } else {
      this.setState({ isScheduleConsultationAllowed: false });
    }

    // 11. Out for Delivery
    if (permissions && permissions.length > 0) {
      const outForDelivery = permissions.filter((item) => {
        return item.name.trim() === "Out for Delivery" && item.is_allowed === 1;
      });
      if (!_isRetail) {
        if (_checkUserRole === USER_ROLES.SUPERADMIN) {
          this.setState({
            isOutForDeliveryAllowed: true,
          });
        } else {
          if (outForDelivery.length > 0) {
            this.setState({
              isOutForDeliveryAllowed:
                outForDelivery[0].is_allowed === 1 ? true : false,
            });
          } else {
            this.setState({
              isOutForDeliveryAllowed: false,
            });
          }
        }
      } else {
        this.setState({ isOutForDeliveryAllowed: false });
      }
    } else {
      this.setState({ isOutForDeliveryAllowed: false });
    }

    // 12. Delivered Items
    if (permissions && permissions.length > 0) {
      const deliveredItems = permissions.filter((item) => {
        return item.name.trim() === "Delivered Items" && item.is_allowed === 1;
      });
      if (!_isRetail) { 
        if (_checkUserRole === USER_ROLES.SUPERADMIN) {
          this.setState({
            isDeliveredItemsAllowed: true,
          });
        } else {
          if (deliveredItems.length > 0) {
            this.setState({
              isDeliveredItemsAllowed:
                deliveredItems[0].is_allowed === 1 ? true : false,
            });
          } else {
            this.setState({
              isDeliveredItemsAllowed: false,
            });
          }
        }
      } else {
        this.setState({
          isDeliveredItemsAllowed: false,
        });
      }
    } else {
      this.setState({ isDeliveredItemsAllowed: false });
    }

    // 13. Loyalty Members
    if (permissions && permissions.length > 0) {
      const loyaltyMembers = permissions.filter((item) => {
        return item.name.trim() === "Loyalty Members" && item.is_allowed === 1;
      });
      if (!_isRetail) {
        if (_checkUserRole === USER_ROLES.SUPERADMIN) {
          this.setState({
            isLoyaltiMembersAllowed: true,
          });
        } else {
          if (loyaltyMembers.length > 0) {
            this.setState({
              isLoyaltiMembersAllowed:
                loyaltyMembers[0].is_allowed === 1 ? true : false,
            });
          } else {
            this.setState({
              isLoyaltiMembersAllowed: false,
            });
          }
        }
      } else {
        this.setState({ isLoyaltiMembersAllowed: false });
      }
    } else {
      this.setState({ isLoyaltiMembersAllowed: false });
    }

    // 14. Order Staging View
    if (permissions && permissions.length > 0) {
      const orderStagingView = permissions.filter((item) => {
        return (
          item.name.trim() === "Order Staging View" && item.is_allowed === 1
        );
      });
      if (!_isRetail) {
        if (_checkUserRole === USER_ROLES.SUPERADMIN) {
          this.setState({
            isOrderStagingViewAllowed: true,
          });
        } else {
          if (orderStagingView.length > 0) {
            this.setState({
              isOrderStagingViewAllowed:
                orderStagingView[0].is_allowed === 1 ? true : false,
            });
          } else {
            this.setState({
              isOrderStagingViewAllowed: false,
            });
          }
        }
      } else {
        this.setState({ isOrderStagingViewAllowed: false });
      }
    } else {
      this.setState({ isOrderStagingViewAllowed: false });
    }

    // 15. Console Report
    if (permissions && permissions.length > 0) {
      const consoleReport = permissions.filter((item) => {
        return item.name.trim() === "Console Report" && item.is_allowed === 1;
      });
      if (!_isRetail) {
        if (_checkUserRole === USER_ROLES.SUPERADMIN) {
          this.setState({ isConsoleReportAllowed: true });
        } else {
          if (consoleReport.length > 0) {
            this.setState({
              isConsoleReportAllowed:
                consoleReport[0].is_allowed === 1 ? true : false,
            });
          } else {
            this.setState({
              isConsoleReportAllowed: false,
            });
          }
        }
      } else {
        this.setState({ isConsoleReportAllowed: false });
      }
    } else {
      this.setState({ isConsoleReportAllowed: false });
    }

    // 16. Patient List
    if (permissions && permissions.length > 0) {
      const PatientList = permissions.filter((item) => {
        return item.name.trim() === "Patient List" && item.is_allowed === 1;
      });
      if (!_isRetail) {
        if (_checkUserRole === USER_ROLES.SUPERADMIN) {
          this.setState({ enrolledPatientsreports: true });
        } else {
          if (PatientList.length > 0) {
            this.setState({
              enrolledPatientsreports:
                PatientList[0].is_allowed === 1 ? true : false,
            });
          } else {
            this.setState({
              enrolledPatientsreports: false,
            });
          }
        }
      } else {
        this.setState({ enrolledPatientsreports: false });
      }
    } else {
      this.setState({ enrolledPatientsreports: false });
    }

    // 17. Payroll Deduction
    if (permissions && permissions.length > 0) {
      const PayrollDeduction = permissions.filter((item) => {
        return (
          item.name.trim() === "Payroll Deduction" && item.is_allowed === 1
        );
      });
      if (!_isRetail) {
        if (_checkUserRole === USER_ROLES.SUPERADMIN) {
          this.setState({ payrollDeductionsreports: true });
        } else {
          if (PayrollDeduction.length > 0) {
            this.setState({
              payrollDeductionsreports:
                PayrollDeduction[0].is_allowed === 1 ? true : false,
            });
          } else {
            this.setState({
              payrollDeductionsreports: false,
            });
          }
        }
      } else {
        this.setState({ payrollDeductionsreports: false });
      }
    } else {
      this.setState({ payrollDeductionsreports: false });
    }

    // 18. InActive Users
    if (permissions && permissions.length > 0) {
      const InActiveUsers = permissions.filter((item) => {
        return item.name.trim() === "InActive Users" && item.is_allowed === 1;
      });
      if (!_isRetail) {
        if (_checkUserRole === USER_ROLES.SUPERADMIN) {
          this.setState({ inActiveUsresAllowed: true });
        } else {
          if (InActiveUsers.length > 0) {
            this.setState({
              inActiveUsresAllowed:
                InActiveUsers[0].is_allowed === 1 ? true : false,
            });
          } else {
            this.setState({
              inActiveUsresAllowed: false,
            });
          }
        }
      } else {
        this.setState({ inActiveUsresAllowed: false });
      }
    } else {
      this.setState({ inActiveUsresAllowed: false });
    }

    // 19. Kiosk Utilization
    if (permissions && permissions.length > 0) {
      const KioskUtilization = permissions.filter((item) => {
        return (
          item.name.trim() === "Kiosk Utilization" && item.is_allowed === 1
        );
      });
      if (!_isRetail) {
        if (_checkUserRole === USER_ROLES.SUPERADMIN) {
          this.setState({ kioskUtilizationAllowed: true });
        } else {
          if (KioskUtilization.length > 0) {
            this.setState({
              kioskUtilizationAllowed:
                KioskUtilization[0].is_allowed === 1 ? true : false,
            });
          } else {
            this.setState({
              kioskUtilizationAllowed: false,
            });
          }
        }
      } else {
        this.setState({ kioskUtilizationAllowed: false });
      }
    } else {
      this.setState({ kioskUtilizationAllowed: false });
    }

    // 20. PMS Logs
    if (permissions && permissions.length > 0) {
      const pmsLogs = permissions.filter((item) => {
        return item.name.trim() === "PMS Logs" && item.is_allowed === 1;
      });
      if (!_isRetail) {
        if (_checkUserRole === USER_ROLES.SUPERADMIN) {
          this.setState({ isPhiLogsVisible: true });
        } else {
          if (pmsLogs.length > 0) {
            this.setState({
              isPhiLogsVisible: pmsLogs[0].is_allowed === 1 ? true : false,
            });
          } else {
            this.setState({
              isPhiLogsVisible: false,
            });
          }
        }
      } else {
        this.setState({ isPhiLogsVisible: false });
      }
    } else {
      this.setState({ isPhiLogsVisible: false });
    }

    // 21. Purge trail
    if (permissions && permissions.length > 0) {
      const purgeTrail = permissions.filter((item) => {
        return item.name.trim() === "Purge trail" && item.is_allowed === 1;
      });
      if (!_isRetail) {
        if (_checkUserRole === USER_ROLES.SUPERADMIN) {
          this.setState({ isPurgeTrailVisible: true });
        } else {
          if (purgeTrail.length > 0) {
            this.setState({
              isPurgeTrailVisible: purgeTrail[0].is_allowed === 1 ? true : false,
            });
          } else {
            this.setState({
              isPurgeTrailVisible: false,
            });
          }
        }
      } else {
        this.setState({ isPurgeTrailVisible: false });
      }
    } else {
      this.setState({ isPurgeTrailVisible: false });
    }

    // 22. Cycle Review
    if (permissions && permissions.length > 0) {
      const CycleReview = permissions.filter((item) => {
        return item.name.trim() === "Cycle Review" && item.is_allowed === 1;
      });
      if (!_isRetail) {
        if (_checkUserRole === USER_ROLES.SUPERADMIN) {
          this.setState({ isCycleReview: true });
        } else {
          if (CycleReview.length > 0) {
            this.setState({
              isCycleReview: CycleReview[0].is_allowed === 1 ? true : false,
            });
          } else {
            this.setState({
              isCycleReview: false,
            });
          }
        }
      } else {
        this.setState({ isCycleReview: false });
      }
    } else {
      this.setState({ isCycleReview: false });
    }

    // 23. Cancelled Items
    if (permissions && permissions.length > 0) {
      const CancelledItems = permissions.filter((item) => {
        return item.name.trim() === "Cancelled Items" && item.is_allowed === 1;
      });
      if (_checkUserRole === USER_ROLES.SUPERADMIN) {
        this.setState({ cancelledItemsReports: true });
      } else {
        if (CancelledItems.length > 0) {
          this.setState({
            cancelledItemsReports:
              CancelledItems[0].is_allowed === 1 ? true : false,
          });
        } else {
          this.setState({
            cancelledItemsReports: false,
          });
        }
      }
    } else {
      this.setState({ cancelledItemsReports: false });
    }
    // 24. Audit Trail is for all.
    if (permissions && permissions.length > 0) {
      const auditTrailReport = permissions.filter((item) => {
        return item.name.trim() === "Audit trail" && item.is_allowed === 1;
      });
      if (_checkUserRole === USER_ROLES.SUPERADMIN) {
        this.setState({ isAuditTrailReportAllowed: true });
      } else {
        if (auditTrailReport.length > 0) {
          this.setState({
            isAuditTrailReportAllowed:
              auditTrailReport[0].is_allowed === 1 ? true : false,
          });
        } else {
          this.setState({
            isAuditTrailReportAllowed: false,
          });
        }
      }
    } else {
      this.setState({ isAuditTrailReportAllowed: false });
    }

    // 25. HL7 Orders.
    if (permissions && permissions.length > 0) {
      const auditTrailReport = permissions.filter((item) => {
        return item.name.trim() === "HL7 Order Staging" && item.is_allowed === 1;
      });
      if (_checkUserRole === USER_ROLES.SUPERADMIN) {
        this.setState({ isHL7OrdersViewVisible: true });
      } else {
        if (auditTrailReport.length > 0) {
          this.setState({
            isHL7OrdersViewVisible:
              auditTrailReport[0].is_allowed === 1 ? true : false,
          });
        } else {
          this.setState({
            isHL7OrdersViewVisible: false,
          });
        }
      }
    } else {
      this.setState({ isHL7OrdersViewVisible: false });
    }
    /** Report Permission End Here */
    if (permissions && permissions.length > 0) {
      const assignPrescriptions = permissions.filter((item) => {
        return item.permission_entity_type === "Assign Prescription";
      });
      const isItemsAllowd = assignPrescriptions.filter(
        (x) => x.is_allowed === 1
      );
      if (isItemsAllowd.length > 0) {
        this.setState({ isDeliverPrescriptionVisible: true });
      } else {
        this.setState({ isDeliverPrescriptionVisible: false });
      }
    } else {
      this.setState({ isDeliverPrescriptionVisible: false });
    }
  }
  render() {
    const { classes, t } = this.props;
    const {
      isIpayTransactionAllowed,
      isTemperatureMonitoringAllowed,
      isReturnToStockAllowed,
      isSurveyReportAllowed,
      isConsultationReportAllowed,
      isScheduleConsultationAllowed,
      isOutForDeliveryAllowed,
      isDeliveredItemsAllowed,
      isLoyaltiMembersAllowed,
      isOrderStagingViewAllowed,
      isConsoleReportAllowed,
      payrollDeductionsreports,
      inActiveUsresAllowed,
      kioskUtilizationAllowed,
      isPhiLogsVisible,
      isPurgeTrailVisible,
      isCycleReview,
      isAuditTrailReportAllowed,
      isDeliverPrescriptionVisible,
      isHL7OrdersViewVisible
    } = this.state;
    const _isRetail = localStorage.getItem("isRetail");
    const accountConnectionId = sessionStorage.getItem("accountConnectionId");
    return (
      <div id="react-no-print">
        {this.state.Dashboard === true && !this.state.DeliveryTech ? (
          <Link
            to={
              [
                false,
                "false",
                undefined,
                "undefined",
                null,
                "null",
                "",
              ].includes(_isRetail)
                ? "/home/"
                : "/home/dashboard"
            }
            style={{ textDecoration: "none" }}
          >
            <ListItemButton className={classes.listItem}>
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText
                primary={t("Leftbar.Dashboard")}
                className={classes.textColor}
              />
            </ListItemButton>
          </Link>
        ) : (
          ""
        )}

        {isDeliverPrescriptionVisible ? (
          <React.Fragment>
            <Divider />
            {[
              false,
              "false",
              undefined,
              "undefined",
              null,
              "null",
              "",
            ].includes(_isRetail) ? (
              <div>
                {this.state.assignprescription === true &&
                !this.state.DeliveryTech ? (
                  this.props.isVisible === true ? (
                    <Link
                      to="/home/prescription/unpluggedassign"
                      style={{ textDecoration: "none" }}
                    >
                      <ListItemButton className={classes.listItem}>
                        <ListItemIcon>
                          <AssignPrescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={t("Leftbar.DeliverPrescription")}
                          className={classes.textColor}
                        />
                      </ListItemButton>
                    </Link>
                  ) : (
                    <Link
                      to="/home/prescription/assign"
                      style={{ textDecoration: "none" }}
                    >
                      <ListItemButton className={classes.listItem}>
                        <ListItemIcon>
                          <AssignPrescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={t("Leftbar.DeliverPrescription")}
                          className={classes.textColor}
                        />
                      </ListItemButton>
                    </Link>
                  )
                ) : (
                  ""
                )}
              </div>
            ) : (
              <Link
                to={
                  [
                    false,
                    "false",
                    undefined,
                    "undefined",
                    null,
                    "null",
                    "",
                  ].includes(_isRetail)
                    ? "/home/create-orders"
                    : "/home/"
                }
                style={{ textDecoration: "none" }}
              >
                <ListItemButton className={classes.listItem}>
                  <ListItemIcon>
                    <AssignPrescriptionIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("Leftbar.CreateLockerPickup")}
                    className={classes.textColor}
                  />
                </ListItemButton>
              </Link>
            )}
          </React.Fragment>
        ) : null}
        {this.state.reports === true && !this.state.DeliveryTech ? (
          <React.Fragment>
            <ListItemButton
              onClick={this.handleClick}
              className={classes.listItem}
            >
              <ListItemIcon>
                <ReportsIcon />
              </ListItemIcon>
              <ListItemText
                inset
                primary={t("Leftbar.Report")}
                className={classes.textColor}
                style={{ paddingLeft: "0px" }}
              />
              {this.state.open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={this.state.open} timeout="auto" unmountOnExit>
              {this.state.assigneditemsreports === true ? (
                <Link
                  to="/home/reports/assigned-items/assigneditems"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.AssignedItemReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {this.state.stockeditemsreports === true ? (
                <Link
                  to="/home/reports/stock-list/StockLists"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.StockedItemReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {this.state.pickedUpitemsreports === true ? (
                <Link
                  to="/home/reports/pickup/PickUpLists"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.PickupItemReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {this.state.cancelledItemsReports === true && (
                <Link
                  to="/home/reports/cancelled-list/CancelledLists"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.CancelledItemsReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              )}
              {this.state.transactionsreports === true ? (
                <Link
                  to="/home/reports/transaction/TransactionLists"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.TransactionsReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {this.state.enrolledPatientsreports === true ? (
                <Link
                  to="/home/reports/enrolled-patients/enrolledpatients"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.PatientListReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {payrollDeductionsreports && (
                <Link
                  to="/home/reports/payroll-deductions/payrollDeductions"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.PayrollDeductionReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              )}
              {isReturnToStockAllowed ? (
                <Link
                  to="/home/reports/return-to-stock/items"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.RetrunToStockItemsReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isSurveyReportAllowed ? (
                <Link
                  to="/home/reports/survey-report/surveyreport"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.SurveyItemReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isConsultationReportAllowed ? (
                <Link
                  to="/home/reports/consultation/consultreport"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.ConsultationReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isScheduleConsultationAllowed ? (
                <Link
                  to="/home/reports/consultation/scheduleconsultreport"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.ScheduleReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isOutForDeliveryAllowed ? (
                <Link
                  to="/home/reports/out-of-delivery/delivery"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.OutForDeliveryReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isDeliveredItemsAllowed ? (
                <Link
                  to="/home/reports/my-delivery/delivery"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.DeliveredItemReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isIpayTransactionAllowed ? (
                <Link
                  to="/home/reports/transaction/ipaytransactions"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.iPayReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {isTemperatureMonitoringAllowed ? (
                <Link
                  to="/home/reports/temperaturemonitoring"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.TemperatureReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {isLoyaltiMembersAllowed ? (
                <Link
                  to="/home/reports/enrolled-loyalty-members"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.LoyaltyReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}

              {isOrderStagingViewAllowed ? (
                <Link
                  to="/home/reports/orders-view"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.OrderStagingReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isConsoleReportAllowed ? (
                <Link
                  to="/home/reports/console-report"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.ConsoleReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {inActiveUsresAllowed && (
                <Link
                  to="/home/reports/inactive-users-report"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.InactiveUserReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              )}
              {kioskUtilizationAllowed && (
                <Link
                  to="/home/reports/kiosk-utilization"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.KioskUtilReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              )}
              {isPhiLogsVisible ? (
                <Link
                  to="/home/reports/phi-logs"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.PhiLogs")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {accountConnectionId === connectionType.THIRD_PARTY ? (
                <Link
                  to="/home/reports/vendor-orders"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.VendorOrdersReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isAuditTrailReportAllowed ? (
                <Link
                  to="/home/reports/audit-trail"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.AuditReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isPurgeTrailVisible ? (
                <Link
                  to="/home/reports/purge-trail-report"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Report.purgeTrail.ReportTitle")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isCycleReview ? (
                <Link
                  to="/home/reports/cycle-report"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Report.CycleReview")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {isHL7OrdersViewVisible ? (
                <Link
                  to="/home/reports/hl7-orders"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.HLOrderStagingReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
                <Link
                  to="/home/reports/message-log"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Report.MessageLog.MessageLogTitle")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
            </Collapse>
          </React.Fragment>
        ) : (
          ""
        )}
      </div>
    );
  }
}

NestedList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(NestedList));



// WEBPACK FOOTER //
// ./src/components/leftnav/reportlink.js